















import { Component, Vue } from 'vue-property-decorator';
import SideBarComponent from '@/components/SideBarComponent.vue';
import SearchInputComponent from '@/components/SearchInputComponent.vue';
import SearchResultsComponent from '@/components/SearchResultsComponent.vue';
import BreadcrumbsComponent from '@/components/BreadcrumbsComponent.vue';
import ToolsBarComponent from '@/components/ToolsBarComponent.vue';
import ButtonsPanelComponent from '@/components/ToolsBar/ButtonsPanelComponent.vue';

@Component({
  name: 'search',
  components: {
    ButtonsPanelComponent,
    BreadcrumbsComponent,
    ToolsBarComponent,
    SideBarComponent,
    SearchInputComponent,
    SearchResultsComponent,
  },
})
export default class Search extends Vue {
}
